import { Range } from "@omni/types/api/product/bff/shared/range.model";
import { CloudRange } from "@omni/types/api/product/cloud/shared/range.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromCloud: ModelMapper<CloudRange, Range> = (model) => {
    return {
        name: model.name,
        from: model.from,
        to: model.to
    } satisfies Range;
};

export const RangeMapper = {
    fromCloud
};
